let menuActive = false;
const flyoutBreakpoint = 1120

const isAboveBreakpoint = (breakpoint) => {
    return !!matchesMediaQuery(breakpoint);
};

const handleClick = () => {
    if (isAboveBreakpoint(flyoutBreakpoint + 1)) {
        return (menuActive = false);
    }

    menuActive = !menuActive;
    document.documentElement.classList.toggle('noScroll');
    document.body.classList.toggle('papFlyoutOpen');
};

$(document).ready(() => {
    const triggers = document.querySelectorAll('.papFlyout__button');
    triggers.forEach((b) => b.addEventListener('click', handleClick));
});

$(window).on(
    'resize',
    debouncer((e) => {
        'use strict';

        // check if above breakout, then remove the classes to show the menu
        if (isAboveBreakpoint(flyoutBreakpoint + 1)) {
            document.documentElement.classList.contains('noScroll') &&
            document.documentElement.classList.remove('noScroll');
            document.body.classList.contains('papFlyoutOpen') &&
            document.body.classList.remove('papFlyoutOpen');
        }

    })
);
